import { render, staticRenderFns } from "./YoutubePopup.vue?vue&type=template&id=f35f86c8&"
import script from "./YoutubePopup.vue?vue&type=script&lang=ts&"
export * from "./YoutubePopup.vue?vue&type=script&lang=ts&"
import style0 from "./YoutubePopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports